import React, { Component } from 'react';
import './Label.css';
import Utils from '../../../base/Utils';

class Button extends Component {
    availableTypes = ['Good', 'Medium', 'Bad'];
    
    render() {
        var text = this.props.text;
        var type = Utils.checkAvailability(this.availableTypes, this.props.type);
        var customBackground = Utils.checkUsage(this.props.customBackground);
        
        var classValue = "Label " + type;
        
        var html = <div style={{backgroundColor: customBackground}} className={classValue}>
        {text}
        </div>;
        
        return html;
    }
}

export default Button;
